import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 4h-3V2h-4v2H7v18h10V4zm-6 16v-5.5H9L13 7v5.5h2L11 20z"
}), 'BatteryChargingFullSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BatteryChargingFullSharp.js
// module id = 2311
// module chunks = 2